const POST_CODE_REGEX = RegExp('^[0-9]{4}$');

export const isValidPostCode = (postCode?: string) => {
  if (!postCode) {
    return false;
  }

  return POST_CODE_REGEX.test(postCode);
};
